import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import ConfirmDialog from './ConfirmDialog';

function getInitial(name) {
  const first = String(name || '').trim();
  if (!first) return 'U';
  return first[0].toUpperCase();
}

export default function SidebarUserFooter({
  onOpenAllUsers,
  onOpenProfile,
  onLogout,
}) {
  const { user, isSuperAdmin } = useAuth();
  const [signOutConfirmOpen, setSignOutConfirmOpen] = useState(false);

  const handleConfirmSignOut = () => {
    setSignOutConfirmOpen(false);
    onLogout?.();
  };

  return (
    <div className="sidebar-footer">
      {isSuperAdmin ? (
        <button
          type="button"
          className="sidebar-action-btn glass-button sidebar-all-users-btn"
          onClick={onOpenAllUsers}
          aria-label="View all users"
          title="View all users"
        >
          <span className="sidebar-dashboard-icon sidebar-all-users-icon" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.8" />
              <path
                d="M3.5 19c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <circle cx="17" cy="8" r="2.4" stroke="currentColor" strokeWidth="1.8" />
              <path
                d="M15.5 13.7c2.4.4 4 2.6 4 5.3"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <span className="sidebar-action-label">All Users</span>
        </button>
      ) : null}

      <div className="sidebar-user-profile">
        <button
          type="button"
          className="sidebar-user-profile-btn"
          onClick={onOpenProfile}
          aria-label="Open profile settings"
          title="Profile settings"
        >
          <div className="sidebar-user-avatar" aria-hidden="true">
            {getInitial(user.name)}
          </div>
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{user.name}</span>
          </div>
        </button>
        <button
          type="button"
          className="sidebar-user-logout-btn"
          onClick={() => setSignOutConfirmOpen(true)}
          aria-label="Sign out"
          title="Sign out"
        >
          <span aria-hidden="true">↩</span>
        </button>
      </div>

      <ConfirmDialog
        open={signOutConfirmOpen}
        title="Sign out?"
        message="You'll need to sign in again to continue."
        confirmLabel="Sign out"
        cancelLabel="Cancel"
        onConfirm={handleConfirmSignOut}
        onCancel={() => setSignOutConfirmOpen(false)}
      />
    </div>
  );
}
